// Dependencies
import { h, Fragment } from "preact";
import { connect } from "react-redux";

// Components
import WidgetComponent from "components/WidgetComponent";
import { Form, Container, Row, Col, I18n } from "components/elements";
import {
	AppointmentFilters,
	WaitingRoom,
	OperatingHours,
} from "components/groups";
import { PatientSelect } from "components/partials";
import { FASpinner } from "components/elements/FontAwesome";
import LoadingIcon from "components/elements/LoadingIcon";

// Actions
import { SessionActions } from "actions";
import { OrganizationActions } from "actions";

// Helpers
import dayjs from "lib/helpers/dayjs";
import processRepeating from "../../../lib/processRepeating";

// Style
import style from "./index.less";

// Class Component
@Form
@connect((state) => state)
class Filters extends WidgetComponent {
	// Constructor
	constructor(props) {
		super(props);
		this.state = {
			authenticator: "",
			authenticatorExists: false,
			processing: false,
			sendReset: false,
		};

		this.handleLogOut = this.handleLogOut.bind(this);
		this.handlePatientSelect = this.handlePatientSelect.bind(this);
		this.handlePasswordResetPrompt = this.handlePasswordResetPrompt.bind(this);
		this.handleBack = this.handleBack.bind(this);
		this.fetchOrganizationData = this.fetchOrganizationData.bind(this);
	}

	// Hook Methods
	componentWillMount() {
		super.componentWillMount();
		// if(this.account.email || this.account.mobilePhone){
		//     if(!this.session.accountID){
		//         this.handleAuthenticatorChange(this.account.email || this.account.mobilePhone)
		//     } else {
		//         this.setState({
		//             authenticator: this.account.email || this.account.mobilePhone
		//         })
		//     }
		// }
	}

	// Getters
	get login() {
		return (this.props.sessions || {}).type === "login";
	}

	get config() {
		return this.props.config || {};
	}

	get appointmentTypes() {
		return Object.values(this.props.appointmentTypes || {}).filter(
			(appType) => {
				if (
					appType.userType &&
					((!(this.props.session || {}).accessToken &&
						appType.userType == "returning") ||
						((this.props.session || {}).accessToken &&
							appType.userType == "new"))
				) {
					return false;
				}
				let maxPatients = 1;
				if (appType.durations) {
					maxPatients = appType.durations.split(",").length;
				}
				if (
					!this.props.filters.patientCount ||
					this.props.filters.patientCount <= maxPatients
				) {
					return true;
				}
				return false;
			}
		);
	}

	get session() {
		return this.props.session || {};
	}

	get account() {
		return this.session.account || {};
	}

	get patients() {
		return Object.values(this.props.patients || {});
	}

	get isButtonDisabled() {
		if (this.props.config.placeholderAppointment) {
			return (
				this.session.accountID &&
				Object.keys(this.props.selectedPatients).length !=
					this.props.filters.patientCount
			);
			// this.session.accountID && this.state.authenticatorExists) || (this.session.accountID && Object.keys(this.props.selectedPatients).length != this.props.filters.patientCount)
		} else {
			return false;
		}
	}

	get openTimes() {
		return (
			processRepeating({
				data: Object.values(this.props.openTimes || {}),
				startingAt: dayjs().startOf("week").format(),
				endingAt: dayjs().endOf("week").format(),
				recast: dayjs,
				getPastItems: true,
			}) || []
		);
	}

	get waitingRoomAdmin() {
		for (let admin of Object.values(this.props.administrators)) {
			if (admin.isWaitingRoom) {
				return admin;
			}
		}
	}

	get waitingRoomHours() {
		let waitingRoomAdmin = this.waitingRoomAdmin;
		if (waitingRoomAdmin) {
			let waitingRoomShifts = this.props.shifts[waitingRoomAdmin.id];
			return (
				processRepeating({
					data: Object.values(waitingRoomShifts || {}),
					startingAt: dayjs().startOf("week").format(),
					endingAt: dayjs().endOf("week").format(),
					recast: dayjs,
					getPastItems: true,
				}) || []
			);
		}
		return [];
	}

	get isWaitingRoomOpen() {
		let now = dayjs();

		let waitingRoomAdmin = this.waitingRoomAdmin;
		let waitingRoomShifts = [];
		if (waitingRoomAdmin) {
			waitingRoomShifts =
				processRepeating({
					data: Object.values(this.props.shifts[waitingRoomAdmin.id] || {}),
					startingAt: dayjs().startOf("day").format(),
					endingAt: dayjs().endOf("day").format(),
					recast: dayjs,
					getPastItems: true,
				}) || [];
		}

		let waitingRoomOpen = false;
		for (let shift of waitingRoomShifts) {
			if (
				now.isSameOrBefore(shift.endsAt) &&
				now.isSameOrAfter(shift.startsAt)
			) {
				waitingRoomOpen = true;
			}
		}

		if (waitingRoomOpen) {
			for (let admin of Object.values(this.props.administrators)) {
				if (!admin.isWaitingRoom) {
					let adminShifts = this.props.shifts[admin.id];
					adminShifts =
						processRepeating({
							data: Object.values(adminShifts || {}),
							startingAt: dayjs().startOf("day").format(),
							endingAt: dayjs().endOf("day").format(),
							recast: dayjs,
							getPastItems: true,
						}) || [];
					for (let shift of adminShifts) {
						if (
							now.isSameOrBefore(shift.endsAt) &&
							now.isSameOrAfter(shift.startsAt)
						) {
							return true;
						}
					}
				}
			}
		}
		return false;
	}

	// Methods

	fetchOrganizationData() {
		if (Object.keys(this.props.breeds).length == 0) {
			OrganizationActions.findPatientDataByID(this.props.organization.id).then(
				(res) => {
					super.componentDidSubmit();
				}
			);
		} else {
			super.componentDidSubmit();
		}
	}

	// navToTimeSlots(submitData) {
	//     if((this.session.accountID || this.account.email || this.account.mobilePhone || (this.state.authenticator && !this.state.authenticatorExists))){
	//         this.fetchOrganizationData()
	//     }
	// }

	handlePasswordResetPrompt() {
		this.setState({
			sendReset: !this.state.sendReset,
		});
	}

	handleBack() {
		SessionActions.logout();
		this.setState({
			authenticator: "",
			authenticatorExists: false,
		});
	}

	handleLogOut() {
		SessionActions.logout();
	}

	handlePatientSelect() {
		this.setState({});
	}

	// Render Method
	render() {		
		let spanValue;
		if (this.props.config.placeholderAppointment) {
			spanValue = 24;
		} else {
			spanValue = 12;
		}
		return (
			<div className={style.filtersContainer}>
				{(this.props.waitingRoom && this.isWaitingRoomOpen) ||
				this.props.loading.waitingRoom ? (
					!this.props.waitingRoom ||
					this.props.loading.organization ||
					this.props.loading.appointments ? (
						<div class={style.spinnerContainer}>
							<LoadingIcon size={100} />
						</div>
					) : (
						<WaitingRoom
							closed={!this.isWaitingRoomOpen}
							spinner={this.props.loading.waitingRoom}
						/>
					)
				) : (
					""
				)}

                {(this.props.waitingRoom && !this.props.loading.organization && !this.isWaitingRoomOpen) && (
					<Container class={style.closedMessage}>
						{_.get(
							this.props,
							"organization.settings.waitingRoomClosedMessage"
						) || (
							<Fragment>
                                <span className={style.headerMessage}>
                                    <I18n>closedMessageWalkInHeader</I18n>
                                </span>
                                <span className={style.contentMessage}>
                                   <I18n>closedMessageWalkInContent</I18n>
                                </span>
							</Fragment>
						)}
					</Container>
				)}

				{this.props.config.showOperatingHours && (
					<Row class={style.showOperatingHours}>
						<Col span={{ sm: 24 }}>
							<OperatingHours
								hours={this.openTimes}
								header={I18n.t("clinicHours")}
								spinner={
									this.props.loading.openTimes ||
									this.props.loading.organization
								}
							/>
						</Col>
						{(this.props.loading.waitingRoom || this.props.waitingRoom) && (
							<Col span={{ sm: 24 }}>
								<OperatingHours
									forceClose={!this.isWaitingRoomOpen}
									hours={this.waitingRoomHours}
									header={I18n.t("onlineCheckIn")}
									spinner={
										this.props.loading.waitingRoom ||
										this.props.loading.organization
									}
								/>
							</Col>
						)}
					</Row>
				)}

				{!(this.props.waitingRoom && !this.props.loading.organization && !this.isWaitingRoomOpen) && (
                    this.props.loading.organization ? (
                        <div style={{ height: "240px", paddingTop: "70px" }}>
                            <FASpinner class={style.spinner} />
                        </div>
                    ) : (
                        /*************************************************************
                         *
                         * APPOINTMENT FILTERS
                         *
                         *************************************************************/
                        <Fragment>
                            {this.appointmentTypes.length > 0 ? (
                                <AppointmentFilters
                                    class={
                                        this.props.config.showOperatingHours
                                            ? style.businessHoursFilterPadding
                                            : style.filterPadding
                                    }
                                    onSubmit={this.fetchOrganizationData}
                                    placeholderAppointment={
                                        this.props.config.placeholderAppointment
                                    }
                                    disabled={this.isButtonDisabled}
                                    PatientCountFilters={{
                                        required: true,
                                        data: this.patientCount,
                                        initialValue: this.props.filters.patientCount,
                                        span: spanValue,
                                    }}
                                    appointmentTypeFilters={{
                                        required: true,
                                        data: this.appointmentTypes,
                                        initialValue: this.props.filters.appointmentTypeID,
                                        span: spanValue,
                                    }}
                                    dateFilters={
                                        !this.props.config.placeholderAppointment && {
                                            required: true,
                                            initialValue: this.props.filters.startDate,
                                            span: 6,
                                        }
                                    }
                                />
                            ) : (
                                <div class={style.noBooking}>
                                    <div
                                        style={{
                                            maxWidth: "600px",
                                            margin: "0xp auto",
                                            display: "inline-block",
                                        }}
                                    >
                                        <Container>
                                            {this.props.session.isReturning ? (
                                                <Fragment>
                                                    <div style={{ textAlign: "left" }}>
                                                        <I18n>noBookingForReturning</I18n>
                                                    </div>
                                                    <br />
                                                    <I18n>thankYouExclamation</I18n>
                                                </Fragment>
                                            ) : (
                                                <Fragment>
                                                    <div style={{ textAlign: "left" }}>
                                                        <I18n>noBookingForNew</I18n>
                                                    </div>
                                                    <br />
                                                    <I18n>thankYouExclamation</I18n>
                                                </Fragment>
                                            )}
                                        </Container>
                                    </div>
                                </div>
                            )}
                        </Fragment>
                    )
                )}
                
				{this.props.config.placeholderAppointment &&
					this.session.accountID &&
					this.props.filters.patientCount && (
						<PatientSelect
							layout="horizontal"
							onPatientSelect={this.handlePatientSelect}
						/>
					)}
				{
					//REMOVE STATE AUTHENTICATOR
				}
				{!this.session.accountID && this.state.authenticatorExists && (
					<div class={style.errorText}>
						<I18n>thisEmailOrPhone</I18n> {this.props.organization.name}
						<I18n>ifThisIsYourFirst</I18n>
						<br />
						<br />
						<br />
					</div>
				)}
				{
					//REMOVE STATE AUTHENTICATOR
				}
				{Object.values(this.props.appointmentTypes || {}).length > 0 &&
					this.appointmentTypes.length == 0 &&
					!this.session.accountID &&
					this.state.authenticator &&
					!this.state.authenticatorExists && (
						<div class={style.errorText}>
							<I18n>noProvideNew</I18n>
							<br />
							<br />
							<br />
						</div>
					)}
				{Object.values(this.props.appointmentTypes || {}).length > 0 &&
					this.appointmentTypes.length == 0 &&
					this.session.accountID && (
						<div class={style.errorText}>
							<I18n>noProvideExisting</I18n>
							<br />
							<br />
							<br />
						</div>
					)}
			</div>
		);
	}
}
export default Filters;



// WEBPACK FOOTER //
// ./components/partials/Filters/index.js